import { ErrorHandler, Injectable } from '@angular/core'

@Injectable({providedIn: 'root'})
export class ErrorHandlerService implements ErrorHandler {
  handleError(error: any) {
    const chunkFailedMessage =
      /Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/
    if (chunkFailedMessage.test(error.message)) {
      console.warn('Chunk load error, reloading...', error)
      window.location.reload()
    } else {
      console.error(error)
    }
  }
}
